module.exports = __webpack_public_path__ + "img/persevere_footer.0714b940.png";